const state = {
  build: null
}

const mutations = {
  SET_CLIPBOARD (state, [name, value]) {
    state[name] = value
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
